__turbopack_context__.v({
  "fadeGlyph": "HeaderLogo-module-scss-module__j-k3fG__fadeGlyph",
  "logo": "HeaderLogo-module-scss-module__j-k3fG__logo",
  "mark": "HeaderLogo-module-scss-module__j-k3fG__mark",
  "markBar": "HeaderLogo-module-scss-module__j-k3fG__markBar",
  "markDot": "HeaderLogo-module-scss-module__j-k3fG__markDot",
  "svg": "HeaderLogo-module-scss-module__j-k3fG__svg",
  "wGlyph": "HeaderLogo-module-scss-module__j-k3fG__wGlyph",
});
